/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * @emails react-core
 */

import Sidebar from './Sidebar';

export default Sidebar;
